/**
 * Image component
 * Outputs image using gatsby-plugin-image or plain SVG
 */

import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Img = ({ localFile, imageAlt, className, imgClassName, objectPosition, objectFit, style }) => {
  const imageFallback = localFile?.publicURL;
  const image = getImage(localFile);
  return (
    <>
      {image ? (
        <GatsbyImage
          image={image}
          alt={imageAlt}
          className={className}
          objectPosition={objectPosition}
          objectFit={objectFit}
          imgClassName={imgClassName}
          style={style}
        />
      ) : (
        imageFallback && (
          <img
            loading="lazy"
            decoding="async"
            src={imageFallback}
            alt={imageAlt}
            className={`${className} ${
              objectFit ? "object-" + objectFit : ""
            } ${objectPosition ? "object-" + objectPosition : ""}`}
            style={style}
          />
        )
      )}
    </>
  );
};

Img.defaultProps = {
  className: "",
  imgClassName: "",
  objectPosition: "center",
};

export default Img;
